<template>
    <span>
        <div v-if="showWeight">
            <p class="mb-0">
                <small>{{ $t('profile.targetsTable.weight') }}</small>
            </p>
            <p class="text-right m-0">{{ formatPercentage(weight) }}%</p>
            <progress-bar :value="weight" />
        </div>
        <div v-else>
            <p class="mb-0">
                <small>{{ $t('profile.targetsTable.calibratedWeight') }}</small>
            </p>
            <p class="text-right m-0">
                {{ formatPercentage(calibratedWeight) }}%
            </p>
            <progress-bar :value="calibratedWeight" />
        </div>
    </span>
</template>

<script>
import ProgressBar from '@/views/components/progress-bar/ProgressBar'
import { formatPercentage } from '@/lib/utils'

export default {
    name: 'Weight',
    props: ['weight', 'calibratedWeight'],
    components: {
        ProgressBar,
    },
    methods: {
        formatPercentage(number) {
            return formatPercentage(number)
        },
    },
    computed: {
        showWeight() {
            return this.weight != undefined
        },
    },
}
</script>
